import 'core-js/stable/promise';
import 'core-js/stable/array/from';
import 'core-js/stable/array/includes';
import 'core-js/stable/array/find-index';
import 'core-js/stable/string/includes';
import * as jQuery from 'jquery';
import 'slick-carousel';
import 'select2';
import 'select2/dist/js/i18n/ru';

import YtApiPlayer from './components/yt-api-player';
import interviewTimer from './components/interview-timer';
import copyText from './components/copy-text';
import defaultSlider from './components/default-slider';
import scrollToElement from './components/scroll-to-element';
import fbCustomEvents from './components/fb-custom-events';
import slider from './components/slider';
import getQuery from './components/query';
import Cookie from './components/cookie';
import bitrixFormCookie from './components/bitrix-form-cookie';
import faceBookPixel from './components/facebook-pixel';

window.$ = window.jQuery = jQuery.default;

((html) => {
    html.className = html.className.replace(/\bno-js\b/, 'js');
})(document.documentElement);

$(() => {
    const query = getQuery(location.search);

    bitrixFormCookie();

    if ('d' in query && (!Cookie.has('deal_id') || Cookie.get('deal_id') !== query.d)) {
        Cookie.set('deal_id', query.d, 48 * 60);
    }

    // new YtApiPlayer({
    //     player_container: '.js-video-iframe',
    //     play_button: '.js-video-play',
    // });

    slider('.reviews-slider', {
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    dots: true,
                }
            },
        ],
    });

    slider('.reviews-slider--blue', {
        dots: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    dots: true,
                }
            },
        ],
    });

    if($('.js-hours').length > 0) {
        interviewTimer();
    }

    $(document).on('click', '.js-change-date', (event) => {
        $('.popup').removeClass('is-hide');
    });

    $('button.popup__close').on('click', () => {
        $('.popup').addClass('is-hide');
    });

    // copyText();

    defaultSlider('.js-comment-slider');

    scrollToElement();

    $('select').select2({
        dropdownParent: $('body'),
        theme: 'default',
        width: 'inherit',
        minimumResultsForSearch: 5,
    });

    setTimeout(function () {
        fbCustomEvents();
        faceBookPixel();
    }, 1000);

    //hamburgerMenu('.js-menu', '.js-hamburger');

    //$('.js-styled-select').niceSelect();

    // $('.js-video-play').on('click', () => {
    //     console.log(666);
    //     $('.js-video-1').hide();
    //     $('.js-video-iframe').show();
    // });

});
